export default "__VITE_ASSET__M6DgeP74__"